import axios from 'axios';

axios.defaults.timeout = 60000;

//const BASE_URL = "https://contractly.ca";
const BASE_URL = process.env.VUE_APP_BASE_URL;
if (process.env.NODE_ENV !== 'production')
    console.log(`http base url =====> ${BASE_URL}`);

const IGNORE_MESSAGES = ["Identity Verification Required", "Your account has not been activated yet.",  "No changes made"];

export const apiUrl = (path) => {
    return `${BASE_URL}${path}`;
};

export const fileUrl = (id) => {
    return `${BASE_URL}/api/cloud/files/${id}`;
};


export const imageUrl = (id, width = 300, height = 300, defImage = "", rmode = 'crop') => {
    if (id && id.length > 2)
        return `${BASE_URL}/api/cloud/images/${id}?width=${width}&height=${height}&rmode=${rmode}`;
    else
        return defImage || "https://placehold.co/600x600?text=NO%20IMAGE";
};

export const uploadUrl = `${BASE_URL}/api/cloud/upload`;


export const captchaUrl = (id) => {
    return `${BASE_URL}/api/common/captcha?id=${id}`;
};





class HttpRequest {
    async request(method, url, data = null) {
        let token = window.$core.data.Token?.AccessToken;

        const options = {
            baseURL: BASE_URL,
            method,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            },
        };

        if (method === "get") {
            options.params = data;
        } else {
            options.data = data;
        }

        if (url.includes("cloud/upload") ) {
            
            var formData = new FormData();
            formData.append("file", data);
            options.data = formData;
        }

        try {
            if (process.env.NODE_ENV !== 'production')
                console.log("HttpRequest:", options);
            window.$loadingBar.start();

            if (url.indexOf('localhost:')>-1)//local test
                url = url.replace('/api', '');

            const res = await axios(url, options);

            if (res && res.data) {
                const responseData = res.data;
                if (responseData?.type > 200 && responseData.content && !IGNORE_MESSAGES.includes(responseData.content)) {
                    window.$message.error(responseData.content);
                }
                //console.log("HttpResponse:", res);
                if (process.env.NODE_ENV !== 'production')
                    console.log("HttpResponse:", capitalizeObjectKeys(res?.data));
                return capitalizeObjectKeys(res.data);
            }
        } catch (error) {

            console.log(error);
            window.$loadingBar.error();

            if (error.response?.status === 401) {
                console.warn("Access token expired. Trying to refresh...");

                const refreshToken = window.$core.data.Token?.RefreshToken;
                if (refreshToken) {
                    try {
                        await this.refreshAccessToken(refreshToken);
                        token = window.$core.data.Token.AccessToken;
                        options.headers['Authorization'] = `Bearer ${token}`;
                        return await this.performRequest(url, options);
                    } catch (refreshError) {
                        //window.$message.error('Session Expired');
                        console.error("Refresh token failed", refreshError);
                        throw refreshError;
                    }
                } else {
                    //window.$message.error(`Error: ${error.message || 'Unknown error'}`);
                    window.$core.clearStorage();
                    window.$router.push('/login');
                }
            } else {
                if (error.response?.data) {
                    //window.$message.error(`${error.response.data.content || 'Unknown error'}`);
                    console.error("Error", error.response.data);
                } else {
                    //window.$message.error(`Error: ${error.message || 'Unknown error'}`);
                    console.error("Error", error.message);
                }
            }
        } finally {
            window.$loadingBar.finish();
        }
    }

    async performRequest(url, options) {
        const res = await axios(url, options);

        if (res && res.data) {
            const responseData = res.data;
            if (responseData?.type > 200 && responseData.content) {
                console.error(responseData.content);
            }
            return res.data;
        } else {
            console.warn("Response data is null:", res);
            throw new Error("Response data is null");
        }
    }

    async refreshAccessToken(refreshToken) {
        const options = {
            baseURL: BASE_URL,
            method: 'post',
            data: { refreshToken },
            headers: {
                'Content-Type': 'application/json',
            }
        };

        const res = await axios('/api/auth/refreshToken', options);
       
        if (res.data?.type === 200) {

            window.$core.setToken(capitalizeObjectKeys(res.data));
            options.method = "get";
            options.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${res.data.AccessToken}`
            };
            const info = await axios('/api/auth/userinfo',options);
            window.$core.setUserInfo(capitalizeObjectKeys(info));
            console.warn("Access token refreshed");
        } else {
            window.$core.clearStorage();
            window.$router.push('/login');
            console.warn("Failed to refresh access token, redirect to login");
            //throw new Error("Failed to refresh access token");
        }
    }
}

const http = new HttpRequest();
export default http;




function capitalizeObjectKeys(obj) {
    // 检查是否是对象或数组
    if (Array.isArray(obj)) {
        return obj.map(item => capitalizeObjectKeys(item));  // 递归处理数组中的每个元素
    } else if (typeof obj === 'object' && obj !== null) {
        const newObj = {};

        Object.keys(obj).forEach(key => {
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);  // 首字母大写
            const value = obj[key];

            // 递归处理嵌套对象或数组
            newObj[capitalizedKey] = capitalizeObjectKeys(value);
        });

        return newObj;
    }

    // 如果是基础类型（如字符串、数字），直接返回
    return obj;
}
